import { useSnackbar } from "notistack";
import { Game, GameData, TeamTurns } from "../../../domain/model/Game";
import { Difficulty } from "../../../domain/model/Question";
import { State } from "../../../domain/model/ResponseState";
import { useNavigate } from "react-router-dom";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";
import { PlayerGetUnfinishedGamesUseCase } from "../../../domain/usecase/player/GetUnfinishedGames/UseCase";
import { useEffect, useState } from "react";
import {
  Category,
  convertCategoryEntityToCategory,
  convertPointsHashmapStringToMap,
} from "../../../domain/model/Category";

export function UnfinishedGamesViewModel(
  playerGetUnfinishedGamesUseCase: PlayerGetUnfinishedGamesUseCase,
) {
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setLoading] = useState(false);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [unfinishedGames, setUnfinishedGames] = useState<Array<Game>>([]);

  const [skip, setSkip] = useState(0);
  const limit = 5;

  const navigate = useNavigate();

  useEffect(() => {
    getUnfinishedGames();
  }, []);

  function convertUnfinshedGameToGameData(
    unfinishedGame: Game,
  ): GameData | undefined {
    if (!unfinishedGame.details) return;
    if (
      unfinishedGame.details.pointsHashmaps.length !=
      unfinishedGame.details.selectedCategories.length
    )
      return;

    const categories: Array<Category> = [];
    unfinishedGame.details.selectedCategories.map(
      (category: any, index: number) => {
        if (!category._id) return;

        const categoryToAdd: Category =
          convertCategoryEntityToCategory(category);
        categoryToAdd.pointsHashmap = convertPointsHashmapStringToMap(
          unfinishedGame.details!.pointsHashmaps[index]!,
        );
        categories.push(categoryToAdd);
      },
    );
    const gameData: GameData = {
      categories,
      resultGame: unfinishedGame,
      firstTeamName: unfinishedGame.details.firstTeamName,
      secondTeamName: unfinishedGame.details.secondTeamName,
      firstTeamScore: unfinishedGame.details.firstTeamScore,
      secondTeamScore: unfinishedGame.details.secondTeamScore,
      currentTeamTurn: unfinishedGame.details.currentTeamTurn,
    };

    return gameData;
  }

  async function continueGame(gameData: GameData) {
    navigate(ROUTE_ENDPOINTS.GAME, {
      state: gameData,
      replace: true,
    });
  }

  async function getUnfinishedGames() {
    if (skip == 0) setLoading(true);
    const response = await playerGetUnfinishedGamesUseCase.invoke(skip, limit);
    setIsLoadingMore(false);
    setLoading(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        if (response.data.length < limit) setShowLoadMoreButton(false);
        else setShowLoadMoreButton(true);
        setUnfinishedGames(unfinishedGames?.concat(response.data));
        setSkip(skip + limit);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }

    return false;
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    convertUnfinshedGameToGameData,
    continueGame,
    getUnfinishedGames,
    isLoading,
    showLoadMoreButton,
    isLoadingMore,
    unfinishedGames,
  };
}
